import { useBusinessScope } from '../contexts/BusinessScopeContext';
import { X, Focus } from 'lucide-react';

/**
 * Slim banner that appears at the top of the shell when the user has
 * temporarily focused the app to a specific business (e.g. by opening a
 * commitment or linked item). Press Esc or click the × to exit.
 */
export default function BusinessScopeBanner() {
  const { scopeBusiness, exitScope } = useBusinessScope();
  if (!scopeBusiness) return null;
  return (
    <div
      data-testid="business-scope-banner"
      className="flex items-center justify-center gap-3 px-4 py-2 text-[11px] font-medium animate-fade-in"
      style={{
        background: `${scopeBusiness.color}18`,
        color: scopeBusiness.color,
        borderBottom: `1px solid ${scopeBusiness.color}40`,
      }}
    >
      <Focus className="w-3.5 h-3.5" />
      <span>
        Focused on <strong>{scopeBusiness.name}</strong> · Press{' '}
        <span className="kbd-pill" style={{ color: 'inherit' }}>Esc</span> to exit
      </span>
      <button
        data-testid="business-scope-banner-exit"
        onClick={exitScope}
        className="pd-icon-button"
        aria-label="Exit scope"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
